import styled from 'styled-components'
import { getConnectionNodes } from 'utils/api'

import Spinner from 'components/display/Spinner'
import Review, { ReviewWrapper } from '../Review'

const ReviewListWrapper = styled.div`
  > div {
    margin-bottom: 16px;
  }
`
const ReviewPlaceholder = styled(ReviewWrapper)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 40px;
`

// Accepts both listing and adventure review connections.
type ReviewConnection = {
  edges?: ({ node?: unknown } | null)[] | null
}

interface ReviewListProps {
  loading?: boolean
  reviewsConnection?: ReviewConnection | null
  condensed?: boolean
}

const ReviewList = ({
  loading,
  reviewsConnection,
  condensed,
}: ReviewListProps) => (
  <ReviewListWrapper>
    {loading && (
      <ReviewPlaceholder>
        <Spinner />
      </ReviewPlaceholder>
    )}

    {!loading &&
      getConnectionNodes(reviewsConnection)
        .filter(Boolean)
        .map((review) => (
          <Review key={review.id} review={review} condensed={condensed} />
        ))}
  </ReviewListWrapper>
)

export default ReviewList
